import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit, ElementRef, ViewChildren, AfterViewInit } from '@angular/core';
import { FormControlName, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GenericValidator } from '../../shared/generic-validator';
import { LoginService } from '../login.service';
import { Observable, fromEvent } from 'rxjs';
import { merge } from 'rxjs/operators';

@Component({
  selector: 'wsg-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  processing = false;
  errorMessage = '';
  successMessage = '';
  forgotPasswordForm: FormGroup;

  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private formBuilder: FormBuilder, private loginService: LoginService, private snackbar: MatSnackBar) {

    this.validationMessages = {
      userName: {
        required: 'Enter a username'
      }
    };

    this.genericValidator = new GenericValidator(this.validationMessages);
  }

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      userName: ['']
    });
  }

  sendResetLink(): void {
    this.errorMessage = '';
    this.successMessage = '';

    this.processing = true;

    this.loginService.sendResetLink(this.forgotPasswordForm.get('userName').value)
                     .subscribe(success => {
                       this.processing = false;
                       this.snackbar.open('Reset Link Sent', 'DISMISS', {
                         duration: 2000
                       });
                     }, error => {
                       this.processing = false;
                       this.errorMessage = error.error;
                     });
  }

  ngAfterViewInit(): void {

    // Watch for the blur event from any input element on the form.
    const controlBlurs: Observable<any>[] = this.formInputElements
                .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

    const valueChanges = this.forgotPasswordForm.valueChanges;

    valueChanges.pipe(merge(...controlBlurs)).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.forgotPasswordForm);
    });
  }


}
